import { Action } from './Action.js';
/**
 * @class EnterFullscreen
 * @extends Action
 * @classdesc �������� ����� � ������������� �����
 * */
export class EnterFullscreen extends Action {
	execute() {
		if (window.ipc) {
			window.ipc.get().sendSync("server", "setFullscreen", true);
			return;
		}

		document.documentElement.requestFullscreen();
	}
}